import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { login } from "api/auth";
import {
  setAuthToken,
  setAuthTokenType,
  setCurrentDeviceDetails,
  setTempCurrentDeviceDetails,
  setUserDetails,
} from "utils/local-storage";

import {
  markStates,
} from "utils/misc";

export const loginThunk = createAsyncThunk(
  "auth/sendOtp",
  async (request, thunkAPI) => {
    try {
      const response = await login(request);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const tempLoginThunk = createAsyncThunk(
  "auth/tempLogin",
  async (request, thunkAPI) => {
    try {
      const response = await login(request);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// export const callerVerificationVerifyOtpThunk = createAsyncThunk(
//   "auth/verifyOtp/api",
//   async (request: GetCallerVerifyOtpRequest, thunkAPI) => {
//     try {
//       const response = await callerVerificationClient.getCallerVerifyUserDetail(
//         request
//       );
//       // store token in local
//       setAuthTokenLocal(response.headers.authorization);
//       removeTemporaryAuthTokenLocal();
//       return response.data;
//     } catch (error: any) {
//       // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
//       return thunkAPI.rejectWithValue(error.message);
//     }
//   }
// );

const initialState = {
  isLoggedIn: false,
  loginError: null,
  deviceType: "Android",
  family: 1,
  appDisable: false,
  activeTab: "dashboard",
  ip: null,
  country: null,
  paypal_client_id: "AXeTVqmbaGBbHZdI23Z_wBtDD6NF7n71MK54VORvFKRoNKNHh6MnkKEnkWLIXHAM-x_3VlkGL1KW4xld",
  userDetails: {
    email: null,
    devices: null,
    email_status: "0",
  },
  currentDeviceStatusSettings: null,
  isvoiprecord: 0,
  phtonfailpin: false,

  currentDevice: null,
  //   isLoginModalOpen: false,
  //   isLoading: false,
  //   userBasicDetails: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    markAuthStore: (state, action) => {
      markStates(action.payload, state);
    },

    logout: (state) => {
      state.isLoggedIn = false;
      //   state.userBasicDetails = null
      //   state.userRole = undefined
      //   cleanCookiesStorage()
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loginThunk.pending, (state) => {
      state.isLoggedIn = false;
    });
    builder.addCase(loginThunk.fulfilled, (state, action) => {
      setAuthToken(action.payload.token);
      setAuthTokenType(action.payload.token_type);
      setUserDetails(action.payload);
      setCurrentDeviceDetails(action.payload.devices[0]);
      setTempCurrentDeviceDetails(action.payload.devices[0]);
      state.isLoggedIn = true;
      state.currentDevice = action.payload.devices[0];
      state.userDetails = action.payload;
    });
    builder.addCase(loginThunk.rejected, (state, action) => {
      state.isLoggedIn = false;
      state.loginError = action.payload.response.data.message;
    });

    builder.addCase(tempLoginThunk.pending, (state) => {
      state.isLoggedIn = false;
    });
    builder.addCase(tempLoginThunk.fulfilled, (state, action) => {
      setAuthToken(action.payload.token);
      setAuthTokenType(action.payload.token_type);
      setUserDetails(action.payload);
      setCurrentDeviceDetails(action.payload.devices[0]);
      setTempCurrentDeviceDetails(action.payload.devices[0]);
      state.isLoggedIn = true;
      state.currentDevice = action.payload.devices[0];
      state.userDetails.email = action.payload.email;
      state.userDetails.devices = action.payload.devices;
    });
    builder.addCase(tempLoginThunk.rejected, (state, action) => {
      state.isLoggedIn = false;
      state.loginError = action.payload.response.data.message;
    });
    // ////////////////// caller Verification Verify OTP thunk /////////////////
    // builder.addCase(callerVerificationVerifyOtpThunk.pending, (state) => {
    //   state.isLoading = true;
    // });
    // builder.addCase(
    //   callerVerificationVerifyOtpThunk.fulfilled,
    //   (state, action) => {
    //     // Store user inside cookies
    //     setUserTokenLocal(action.payload.userId);
    //     // Store user session isValid  to redux
    //     state.isLoading = false;
    //   }
    // );
    // builder.addCase(callerVerificationVerifyOtpThunk.rejected, (state) => {
    //   state.isLoading = false;
    // });
  },
});

export const { logout, markAuthStore } = authSlice.actions;

export const selectIsUserLoggedIn = (state) => state.authReducer.isLoggedIn;
export const selectDeviceType = (state) => state.authReducer.deviceType;
export const selectDeviceFamily = (state) => state.authReducer.family;
export const selectUserDetails = (state) => state.authReducer.userDetails;
export const selectUserCountryCode = (state) => state.authReducer.country;
export const selectUserIpAddress = (state) => state.authReducer.ip;
export const selectUserDevices = (state) =>
  state.authReducer.userDetails.devices;
export const selectCurrentDevice = (state) => state.authReducer.currentDevice;
export const selectCurrentDeviceStatusSettings = (state) =>
  state.authReducer.currentDeviceStatusSettings;
export const selectLoginError = (state) => state.authReducer.loginError;
export const selectIsvoiprecord = (state) => state.authReducer.isvoiprecord;
export const selectPhtonfailpin = (state) => state.authReducer.phtonfailpin;
export const selectAppDisable = (state) => state.authReducer.appDisable;
export const selectActiveTab = (state) => state.authReducer.activeTab;
export const selectpaypalClientId = (state) => state.authReducer.paypal_client_id;

export default authSlice.reducer;
